<div class="global-loader-spinner-wrap" *ngIf="loadingMessage$.value != null">
  <div class="question card">
    <div class="card-header">
      <div class="global-loader-spinner">
        <div class="loader"><div class="ball-pulse"><div></div><div></div><div></div></div></div> {{ loadingMessage$.value }}
      </div>
    </div>
  </div>
</div>
